module.exports = __webpack_public_path__ + "static/media/36_Schalla_webfinal.189e8ad7.jpg";